module.exports = __webpack_public_path__ + "img/ranger-front-fr-FR.ff185fa8.png";